export default {
	methods: {
		showFromElement(elementOrId) {
			this.$children[0].showFromElement(elementOrId)
		}
	}
}
